"use client";
import React, { useEffect, useState } from "react";
import { useLocalization } from "@/providers/LocalizationProvider";

// const tips: string[] = [
//   "Complete your profile, <b>it's your calling card!</b><br>What are you waiting for to showcase your talent?",
//   "Participate in <b>KudoZ</b> by helping others.<br>Do you have the answer?<br>Share it!",
//   "Unlock <b>opportunities</b> by getting a <b>professional membership.</b><br>You'll have more work!",
//   "Be the expert they're looking for. <b>Edit your specialties</b> in your profile.",
//   "Find your next project in the <b>Opportunities marketplace.</b><br>What interests you today? Apply!",
//   "See <b>Learning</b> at <u>ProZ.com</u> and invest in your future.<br>What course will you take?",
// ];

const getRandomTip = (tips: string[], currentTip: string): string => {
  if (!tips || tips.length === 0) return "";
  let newTip;
  do {
    newTip = tips[Math.floor(Math.random() * tips.length)];
  } while (newTip === currentTip);
  return newTip;
};

interface PageLoaderProps {
  initialTip: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ initialTip }) => {
  const [tip, setTip] = useState<string>(initialTip);
  const [animation, setAnimation] = useState<string>("fadeIn");
  const [theme, setTheme] = useState<string | null>(null);

  const dict = useLocalization();
  const tips: string[] = Object.keys(dict?.loader_tips || {}).map((key) => dict.loader_tips[key]);

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    setTheme(storedTheme);
    if (!tips.includes(tip)) {
      setTip(getRandomTip(tips, tip));
    }
    const changeTip = () => {
      setAnimation("fadeOut");
      setTimeout(() => {
        setTip(getRandomTip(tips, tip));
        setAnimation("fadeIn");
      }, 500); // Reduced timeout for smoother transitions
    };

    const interval = setInterval(changeTip, 5000);
    return () => clearInterval(interval);
  }, [tip, tips]);

  return (
    <div
      className={`fixed inset-0 flex flex-col justify-center items-center z-[9999] p-8 text-center ${
        theme == "dark" ? "bg-black text-white" : "bg-white/90"
      } text-gray-800`}
    >
      <div className="p-8 rounded-lg w-[600px] h-[400px] max-w-[60vw] max-h-[60vh] flex flex-col items-center justify-center">
        <div className="flex items-center justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 512 512"
            className="animate-bounce"
          >
            <path
              d="M234.692 432.648C94.684 415.713 28.908 249.208 119.604 141.314c81.71-97.204 237.25-79.643 294.818 33.286 64.582 126.688-38.784 275.096-179.73 258.048"
              fill="#f9f9f9"
            />
            <path
              d="M228.979 480.01C51.432 458.535-31.98 247.387 83.033 110.564 186.651-12.702 383.895 9.568 456.898 152.775c81.898 160.656-49.183 348.855-227.92 327.235m-53.88-168.724v-22.648h187.457l6.971-2.688c47.63-18.368 48.594-81.005 1.618-105.051l-5.538-2.835-60.838-.287c-33.461-.158-78.923-.011-101.027.327l-40.189.614v100.151h-57.73v9.769h57.73v45.296h11.546zm0-79.057v-44.863l93.94.234 93.942.234 6.198 3.032c36.53 17.87 35.189 68.775-2.218 84.166l-4.907 2.018-93.477.021-93.478.021z"
              fill="#4d9d9d"
            />
            <path
              d="M228.979 480.01C51.432 458.535-31.98 247.387 83.033 110.564 186.651-12.702 383.895 9.568 456.898 152.775c81.898 160.656-49.183 348.855-227.92 327.235m-53.88-168.724v-22.648h187.457l6.971-2.688c47.63-18.368 48.594-81.005 1.618-105.051l-5.538-2.835-60.838-.287c-33.461-.158-78.923-.011-101.027.327l-40.189.614v100.151h-57.73v9.769h57.73v45.296h11.546zm0-79.057v-44.863l93.94.234 93.942.234 6.198 3.032c36.53 17.87 35.189 68.775-2.218 84.166l-4.907 2.018-93.477.021-93.478.021z"
              fill="#2e6969"
            />
          </svg>
        </div>
        <p className="flex items-center justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 text-yellow-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 2a7 7 0 00-7 7c0 2.386 1.053 4.5 2.7 5.9.3.25.3.7.3 1.1v.5a1 1 0 001 1h6a1 1 0 001-1v-.5c0-.4 0-.85.3-1.1A7.003 7.003 0 0019 9a7 7 0 00-7-7zM9 21h6M10 18h4"
            />
          </svg>
        </p>
        <div
          className={`text-base leading-relaxed transition-opacity duration-500 ease-in-out ${
            animation === "fadeIn" ? "opacity-100" : "opacity-0"
          }`}
          dangerouslySetInnerHTML={{ __html: tip }}
        />
      </div>
    </div>
  );
};

export default PageLoader;
